module.exports = __webpack_public_path__ + "img/ic_map_hotel_label_2_stars.80fc74b1.svg";